export default {
  title: 'Ristoranti di test',
  description:
    'Ogni partner può contrassegnare un ristorante come proprio ristorante di test. Funziona come qualsiasi altro ristorante e non viene mai fatturato. Viene inviato un avviso Slack quando le sue vendite del mese superano la soglia.',
  empty: 'Nessun partner ha un ristorante di test.',
  columns: {
    partner: 'Partner',
    restaurant: 'Ristorante',
    designated: 'Contrassegnato come test',
    gmv: 'GMV questo mese',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Sospeso',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Nessun tasso di cambio memorizzato',
  },
  actions: {
    remove: 'Rimuovi designazione Test',
  },
  toasts: {
    load_error: 'Impossibile caricare i ristoranti di test.',
  },
};
